export const FAQS = [
  {
    q: "What is Senior Stylist?",
    a: "Senior Stylist is an on-demand, message-based hair consultation subscription. You message certified senior stylists in the app for personalised guidance on hair care, colour, styling and scalp health, advice you can follow at home or take to your local hairdresser. It does not involve physical cutting or colouring.",
  },
  {
    q: "How does it work?",
    a: "Download the Senior Stylist app, sign in with your phone number, and complete the 15-question Style DNA Matrix. We then match you with a certified senior stylist you can message for personalised advice.",
  },
  {
    q: "What's included for £12 a month?",
    a: "Your £12 monthly subscription includes: two message-based consultations per month, each capped at a maximum of 10 minutes though most last just a few minutes (use-it-or-lose-it, they don't roll over to the next month), three hairstyle try-ons, Style DNA matching product recommendations, an Event Planner, and a Style DNA analysis. You can cancel anytime. Please note: message-based consultations are launching soon, sign up now to register your interest and we'll let you know the moment they go live.",
  },
  {
    q: "How do payments work and can I cancel?",
    a: "Payments are handled securely through Stripe, so we never store your card details. You can cancel your subscription at any time; refunds are subject to conditions, just email support@senior-stylist.com.",
  },
  {
    q: "Are the stylists qualified?",
    a: "Yes. Every stylist is a vetted professional holding at least NVQ Level 2 (or equivalent) with a minimum of 5 years' experience. There are no juniors or apprentices on the platform.",
  },
  {
    q: "Can I choose my own stylist?",
    a: "Yes. After the Style DNA Matrix you're shown your closest matches, typically your five best. You can read each stylist's bio and choose the one who best suits you and your specific hair needs.",
  },
  {
    q: "Can I use the same stylist again?",
    a: "Yes. If that stylist is available and appears among your five suggested best matches, you can choose her again.",
  },
  {
    q: "How quickly do stylists reply?",
    a: "Stylists usually reply very quickly, typically within about a minute. It's an on-demand, 24/7 message-based service.",
  },
  {
    q: "How long is a consultation?",
    a: "Each consultation is capped at a maximum of 10 minutes, but most only last a few minutes. Your stylist has your Style DNA and photos upfront, so the time is focused purely on your questions and advice.",
  },
  {
    q: "Where is Senior Stylist available?",
    a: "Globally. We have stylists all over the world who connect with clients everywhere through the Style DNA Matrix. The app is available on the Apple App Store and Google Play.",
  },
  {
    q: "Can I share photos with my stylist?",
    a: "Yes, you can securely share photos with your stylist inside the app so they can give you the most accurate guidance.",
  },
  {
    q: "Do you sell hair products?",
    a: "Yes. We have an online store selling our own bespoke, vegan-friendly range of hair products.",
  },
  {
    q: "How do I become a stylist?",
    a: "If you meet the criteria you can join the Senior Stylist stylist waitlist. Once your Style DNA match is complete, your account is activated and you can join the team. You must be at least 18, hold at least NVQ Level 2 (or equivalent), and have a minimum of 5 years' experience as a stylist.",
  },
  {
    q: "What age do I need to be to use the service?",
    a: "You must be at least 18 years old to use Senior Stylist.",
  },
  {
    q: "Is my data and payment secure?",
    a: "Yes, we take your privacy and security seriously. Payments are processed by Stripe, a leading global payment provider, so your card details are never stored on our systems. Your personal information is handled in line with UK GDPR and the Data Protection Act 2018, all data is sent over encrypted (HTTPS) connections, and we only ever share it with the trusted providers needed to run the service. You can read exactly how we collect, use and protect your data in our Privacy Policy.",
  },
  {
    q: "Who owns Senior Stylist?",
    a: "Senior Stylist is owned by SS Tech Holdings Limited, a private company registered at Companies House, based in London.",
  },
];
